import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcDistrictCode = DatabaseCode;

const rrc1: RrcDistrictCode = {
  code: "RRC_1",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc1",
    defaultMessage: "RRC District 1",
  },
};

const rrc2: RrcDistrictCode = {
  code: "RRC_2",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc2",
    defaultMessage: "RRC District 2",
  },
};

const rrc3: RrcDistrictCode = {
  code: "RRC_3",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc3",
    defaultMessage: "RRC District 3",
  },
};

const rrc4: RrcDistrictCode = {
  code: "RRC_4",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc4",
    defaultMessage: "RRC District 4",
  },
};

const rrc5: RrcDistrictCode = {
  code: "RRC_5",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc5",
    defaultMessage: "RRC District 5",
  },
};

const rrc6: RrcDistrictCode = {
  code: "RRC_6",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc6",
    defaultMessage: "RRC District 6",
  },
};

const rrc7b: RrcDistrictCode = {
  code: "RRC_7B",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc7b",
    defaultMessage: "RRC District 7B",
  },
};

const rrc7c: RrcDistrictCode = {
  code: "RRC_7C",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc7c",
    defaultMessage: "RRC District 7C",
  },
};

const rrc8: RrcDistrictCode = {
  code: "RRC_8",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc8",
    defaultMessage: "RRC District 8",
  },
};

const rrc8a: RrcDistrictCode = {
  code: "RRC_8A",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc8a",
    defaultMessage: "RRC District 8A",
  },
};

const rrc9: RrcDistrictCode = {
  code: "RRC_9",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc9",
    defaultMessage: "RRC District 9",
  },
};

const rrc10: RrcDistrictCode = {
  code: "RRC_10",
  displayValue: {
    id: "common.entity.rrcdistrict.rrc10",
    defaultMessage: "RRC District 10",
  },
};

export const rrcDistrictCode = {
  rrc1,
  rrc2,
  rrc3,
  rrc4,
  rrc5,
  rrc6,
  rrc7b,
  rrc7c,
  rrc8,
  rrc8a,
  rrc9,
  rrc10,
};

export const rrcDistrictCodes: RrcDistrictCode[] = Object.values(rrcDistrictCode);

export const toRrcDistrictCodeCode = (code: string): RrcDistrictCode =>
  toDatabaseCode(code, rrcDistrictCodes);

export const toRrcDistrictCodeCodeSafely = (
  code: string | undefined,
  defaultValue: RrcDistrictCode | undefined = undefined
): RrcDistrictCode | undefined => toDatabaseCodeSafely(code, rrcDistrictCodes, defaultValue);
